import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"

//Import images 
import avatar4 from "../../../assets/images/users/profile.png"

//i18n
import { withTranslation } from "react-i18next"
import { app_url, website_link } from "app_config"
import { axiosbaseurl } from "configure"
import moment from "moment"

const NotificationDropdown = props => {
  const [menu, setMenu] = useState(true)

  useEffect(() => {
    setMenu(false)
  }, [])

  useEffect(() => {
    if (menu) {
      (async () => {
        try {
          const response = await axiosbaseurl.get("/bell-notification/today")
          if (response.data.success) {
            props.setNotifications(response.data.data)

            // console.log(
            //   `${process.env.REACT_APP_IMAGE_PATH}/${response.data.data[0].profileImage}`
            // )
          }
        } catch (error) {
          console.log(error)
        }
      })()
    }
  }, [menu])
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" />
          {props.notifications.length ? (
            <span className="badge bg-danger rounded-circle">
              {props.notifications.length}
            </span>
          ) : null}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Today's Notification")} </h6>
              </Col>
              <div className="col-auto">
                {/* <Link to={`${app_url}notifications`} className="small">
                  {" "}
                  View All
                </Link> */}
                <h6 className="m-0 text-cyan bg-light border p-1 rounded">
                  {moment().format("DD MMM YYYY")}
                </h6>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "240px" }}>
            {props?.notifications?.map((item, index) => {
              return (
                <Link
                  key={index}
                  to={`${app_url}${item?.module?.trim() || ''}`}
                  className="text-reset notification-item"
                  onClick={() => setMenu(false)}
                >
                  <div className="d-flex">
                    <div className="avatar-xs me-3">
                      <span className="avatar-picture rounded-circle font-size-16">
                        <img
                          src={
                            item.profileImage &&
                              item.profileImage.trim() !== "" &&
                              item.profileImage !== "null"
                              ? `${process.env.REACT_APP_IMAGE_PATH}/${item.profileImage}`
                              : avatar4
                          }
                          className="avatar-img"
                          alt="img"
                        />
                      </span>
                    </div>
                    <div className="flex-grow-1">
                      <h6 className="mt-0 mb-1">{props.t(item.title)}</h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />{" "}
                          {moment(item.createdAt).format("hh:mm A")}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              )
            })}
            {props.notifications.length === 0 && (
              <div className="text-center mt-2 text-secondary">
                No notification available.
              </div>
            )}
          </SimpleBar>
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 text-center"
              to={`${app_url}notifications`}
              onClick={() => setMenu(false)}
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
              <span key="t-view-more">{props.t("View All")}</span>
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}
